var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A0A1A1",
    fillRule: "evenodd",
    d: "M1.9 5.5c0-1.71 1.39-3.1 3.1-3.1h4V.5H5c-2.76 0-5 2.24-5 5s2.24 5 5 5h4V8.6H5c-1.71 0-3.1-1.39-3.1-3.1m4.1 1h8v-2H6zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1S16.71 8.6 15 8.6h-4v1.9h4c2.76 0 5-2.24 5-5s-2.24-5-5-5"
  })));
});
const SvgMatchingIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMatchingIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDIwIDExIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iI0EwQTFBMSI+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEuOSA1YzAtMS43MSAxLjM5LTMuMSAzLjEtMy4xaDRWMEg1QzIuMjQgMCAwIDIuMjQgMCA1czIuMjQgNSA1IDVoNFY4LjFINUMzLjI5IDguMSAxLjkgNi43MSAxLjkgNXpNNiA2aDhWNEg2djJ6bTktNmgtNHYxLjloNGMxLjcxIDAgMy4xIDEuMzkgMy4xIDMuMSAwIDEuNzEtMS4zOSAzLjEtMy4xIDMuMWgtNFYxMGg0YzIuNzYgMCA1LTIuMjQgNS01cy0yLjI0LTUtNS01eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyODAuMDAwMDAwLCAtNTIwLjAwMDAwMCkgdHJhbnNsYXRlKDYwLjAwMDAwMCwgNjAuMDAwMDAwKSB0cmFuc2xhdGUoODAuMDAwMDAwLCAyNzguMDAwMDAwKSB0cmFuc2xhdGUoMC4wMDAwMDAsIDYwLjAwMDAwMCkgdHJhbnNsYXRlKDMwLjAwMDAwMCwgNjAuMDAwMDAwKSB0cmFuc2xhdGUoMC4wMDAwMDAsIDUwLjAwMDAwMCkgdHJhbnNsYXRlKDEwOTAuMDAwMDAwLCAwLjAwMDAwMCkgdHJhbnNsYXRlKDE3LjAwMDAwMCwgNC41MDAwMDApIHRyYW5zbGF0ZSgzLjAwMDAwMCwgOC4wMDAwMDApIi8+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";